import { Injectable } from '@angular/core';
import { ProfileReaderService } from '@services/profile-reader/profile-reader.service';
import { ProfileService } from '@services/profile/profile.service';
import { AddinExecute, Execute } from '@techwan/ionic-core';
import { filter, first } from 'rxjs';
import { CallcardDetailStampsFreetext } from '../../../components/callcard-detail-stamps-freetext/callcard-detail-stamps-freetext.component';
import { CardsProviderService } from '../../cards-provider/cards-provider.service';

@AddinExecute({
  name: 'CallcardSetup',
  description: 'Setup dynamic views in the callcard details'
})
@Injectable()
export class CallcardSetupService extends Execute {
  constructor(
    private profileService: ProfileService,
    private profileReader: ProfileReaderService,
    private cardsProvider: CardsProviderService
  ) {
    super();
  }

  execute() {
    this.profileService.ready
      .pipe(
        filter(isReady => isReady),
        first()
      )
      .subscribe(() => {
        const showFreeTextTypes: number[] = this.profileReader.getComponentConfig('singlecallcard', 'showFreeTextTypes', []);
        if (showFreeTextTypes?.length) {
          this.cardsProvider.add(CallcardDetailStampsFreetext);
        }
      });
  }
}
